<template>
  <div class="slider">
    <!-- Liste (Ana Slaytlar) -->
    <div class="list">
      <div
        v-for="(item, index) in slides"
        :key="index"
        class="item"
        :class="{ active: index === activeIndex }"
        @click="openLink(item.link)"
        style="cursor: pointer"
      >
        <img :src="getImageUrl(item.image)" />
        <div class="content">
          <p :style="{ color: item.title_color || '#ffffff' }">{{ item.category }}</p>
          <h2 :style="{ color: item.title_color || '#ffffff' }">{{ item.title }}</h2>
          <p :style="{ color: item.desc_color || '#dddddd' }">{{ item.description }}</p>
        </div>
        <div class="overlay"></div>
      </div>
    </div>

<!-- Ok Butonları - sola ve sağa ayrılmış -->
    <div class="arrow-left">
      <button @click="prevSlide">&lt;</button>
    </div>
    <div class="arrow-right">
      <button @click="nextSlide">&gt;</button>
    </div>

    <!-- Thumbnail -->
    <div class="thumbnail">
    <div
      v-for="(item, index) in slides"
      :key="'thumb-' + index"
      class="item"
      :class="{ active: index === activeIndex }"
      @click="goToSlide(index)"
    >
      <img :src="getImageUrl(item.image)" />
      <div class="content" :style="{ color: item.title_color || '#fff' }">
        {{ item.title }}
      </div>
    </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import axios from 'axios' // axios'u ekledik
const baseUrl = process.env.VUE_APP_API_URL
const slides = ref([])
const activeIndex = ref(0)
let interval = null


const getImageUrl = (path) => {
  if (!path || typeof path !== 'string') return ''
  return path.startsWith('/uploads')
    ? `${baseUrl}${path}`
    : path
}
const nextSlide = () => {
  if (slides.value.length === 0) return
  activeIndex.value = (activeIndex.value + 1) % slides.value.length
  showSlider()
}

const prevSlide = () => {
  if (slides.value.length === 0) return
  activeIndex.value = (activeIndex.value - 1 + slides.value.length) % slides.value.length
  showSlider()
}

const goToSlide = (index) => {
  if (slides.value.length === 0) return
  activeIndex.value = index
  showSlider()
}
const scrollToThumbnail = () => {
  setTimeout(() => {
    const thumbnails = document.querySelectorAll('.thumbnail .item')
    const activeThumb = thumbnails[activeIndex.value]
    if (activeThumb) {
      activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', black: 'nearest' })
    }
  }, 500)
}

const resetInterval = () => {
  clearInterval(interval)
  interval = setInterval(nextSlide, 5000)
}

const showSlider = () => {
  /*scrollToThumbnail()*/
  resetInterval()
}

const openLink = (url) => {
  if (url) {
    if (url.startsWith('/')) {
      window.location.href = url // Vue route'u aynı sekmede aç
    } else {
      window.open(url, '_blank') // Dış bağlantıları yeni sekmede aç
    }
  }
}

const fetchSlides = async () => {
  try {
    const res = await axios.get('/sliders')    
    slides.value = res.data
    console.log('Tam yanıt:', res)
   console.log('Veri:', res.data)
    console.log('Durum kodu:', res.status)
    console.log('Başlıklar:', res.headers)
  } catch (error) {
    console.error('Slider verisi alınamadı:', error.response?.data || error.message || error)

  }
}

onMounted(async () => {
  await fetchSlides()
  if (slides.value.length > 0) {
    interval = setInterval(nextSlide, 5000)
  }
})

onUnmounted(() => {
  clearInterval(interval)
})
</script>

<style scoped>
/* CSS aynı kalabilir, sadece ek olarak cursor pointer */
.slider {
  height: 100vh;
  position: relative;
  font-family: 'Poppins', sans-serif;
  overflow: hidden; /* ✨ kaymayı engeller */
}
.list .item {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: 0.5s;
}
.list .item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.list .item::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, #000 40%, transparent);
}
.list .item .content {
  position: absolute;
  left: 10%;
  top: 20%;
  max-width: 500px;
  z-index: 2;
}
.list .item .content p:nth-child(1) {
  text-transform: uppercase;
  letter-spacing: 10px;
}
.list .item .content h2 {
  font-size: 80px;
  margin: 0;
}
.item.active {
  opacity: 1;
  z-index: 10;
}
.item.active p:nth-child(1),
.item.active h2,
.item.active p:nth-child(3) {
  transform: translateY(30px);
  filter: blur(20px);
  opacity: 0;
  animation: showContent 0.7s ease-in-out forwards;
}
.item.active h2 {
  animation-delay: 1s;
}
.item.active p:nth-child(3) {
  animation-delay: 1.3s;
}
@keyframes showContent {
  to {
    transform: translateY(0);
    filter: blur(0);
    opacity: 1;
  }
}
.arrow-left,
.arrow-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
}

.arrow-left {
  left: 30px;
}

.arrow-right {
  right: 30px;
}

.arrow-left button,
.arrow-right button {
  background: #eee5;
  border: none;
  width: 40px;
  height: 40px;
  font-size: x-large;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.arrow-left button:hover,
.arrow-right button:hover {
  background: #fff;
  color: #000;
}
.thumbnail {
  position: absolute;
  bottom: 50px;
  z-index: 11;
  display: flex;
  gap: 10px;
  width: 100%;
  padding: 0 50px;
  overflow: auto;
  justify-content: center;
}
.thumbnail::-webkit-scrollbar {
  width: 0;
}
.thumbnail .item {
  width: 150px;
  height: 220px;
  filter: brightness(0.5);
  transition: 0.5s;
  flex-shrink: 0;
  position: relative;
}
.thumbnail .item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.thumbnail .item.active {
  filter: brightness(1.5);
}
.thumbnail .item .content {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: white;
  font-size: 12px;
}
@media screen and (max-width: 768px) {
  .list .item .content {
    top: 15%;
    left: 6%;
    max-width: 90%;
  }

  .list .item .content h2 {
    font-size: 40px;
  }

  .list .item .content p:nth-child(3) {
    font-size: 14px;
  }

  .arrow-left,
  .arrow-right {
    top: 90%;
    transform: translateY(0);
  }

  .arrow-left {
    left: 10px;
  }

  .arrow-right {
    right: 10px;
  }

  .arrow-left button,
  .arrow-right button {
    width: 36px;
    height: 36px;
    font-size: 20px;
  }

  .thumbnail {
    padding: 0 10px;
    bottom: 90px;
    gap: 6px;
  }

  .thumbnail .item {
    width: 100px;
    height: 150px;
  }

  .thumbnail .item .content {
    font-size: 10px;
    left: 8px;
  }
}

@media screen and (max-width: 480px) {
  .list .item .content h2 {
    font-size: 30px;
  }

  .list .item .content p:nth-child(1),
  .list .item .content p:nth-child(3) {
    font-size: 12px;
  }

  .thumbnail .item {
    width: 80px;
    height: 120px;
  }
}
</style>
